import Body from "../components/Body";
import RecipeContainer from "../components/recipes/RecipeContainer";

export default function RecipeDashboardPage() {
  return (
    <Body sidebar>
      <RecipeContainer />
    </Body>
  );
}
